/*
  Richieste dal sito: dati in piu' nei moduli di contatto (04/11/2026). File
  uguale sui 4 temi (Amonn, GuestSide, LaMystique, Vestige).

  - Aggiunge Struttura / azienda (facoltativo), Nazione, Provincia (solo
    Italia) e Citta' (obbligatori) a ogni modulo contatti, tranne avviso di
    disponibilita', recesso e verifica VIES. I campi copiano il contenitore
    del campo email del modulo, cosi' prendono lo stile del tema.
  - Cliente registrato: li precompila dalla fatturazione dichiarata nel
    modulo prezzi (billing.billing_address), altrimenti dall'indirizzo
    predefinito; se non ha indirizzi restano vuoti
    (snippets/site-request-customer.liquid).
  - Provenienza della visita, come sorgente / mezzo di GA4: utm, gclid,
    referrer. Prima visita e ultima visita non diretta, 90 giorni in localStorage.

  assets/site-requests.js prende tutto con window.SiteRequestFields.collect(form)
  e lo manda al PIM (core/site_requests.py).
*/
(function () {
  var STORE_KEY = 'pim_site_request_attribution';
  var MAX_AGE = 90 * 24 * 3600 * 1000;

  // Stesso elenco di COUNTRY_NAMES in core/site_requests.py del PIM.
  var COUNTRIES = ['IT', 'AT', 'BE', 'BG', 'CY', 'HR', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'IE', 'LV',
    'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'CZ', 'RO', 'SK', 'SI', 'ES', 'SE', 'HU', 'AD', 'CH', 'GB',
    'IS', 'LI', 'MC', 'NO', 'SM', 'VA'];
  var OTHER_COUNTRY = 'ZZ';
  // Province italiane con la sigla di Shopify (come il modulo prezzi).
  var PROVINCES = [["AG", "Agrigento"], ["AL", "Alessandria"], ["AN", "Ancona"], ["AO", "Aosta"], ["AR", "Arezzo"], ["AP", "Ascoli Piceno"], ["AT", "Asti"], ["AV", "Avellino"], ["BA", "Bari"], ["BT", "Barletta-Andria-Trani"], ["BL", "Belluno"], ["BN", "Benevento"], ["BG", "Bergamo"], ["BI", "Biella"], ["BO", "Bologna"], ["BZ", "Bolzano"], ["BS", "Brescia"], ["BR", "Brindisi"], ["CA", "Cagliari"], ["CL", "Caltanissetta"], ["CB", "Campobasso"], ["CE", "Caserta"], ["CT", "Catania"], ["CZ", "Catanzaro"], ["CH", "Chieti"], ["CO", "Como"], ["CS", "Cosenza"], ["CR", "Cremona"], ["KR", "Crotone"], ["CN", "Cuneo"], ["EN", "Enna"], ["FM", "Fermo"], ["FE", "Ferrara"], ["FI", "Firenze"], ["FG", "Foggia"], ["FC", "Forlì-Cesena"], ["FR", "Frosinone"], ["GE", "Genova"], ["GO", "Gorizia"], ["GR", "Grosseto"], ["IM", "Imperia"], ["IS", "Isernia"], ["AQ", "L'Aquila"], ["SP", "La Spezia"], ["LT", "Latina"], ["LE", "Lecce"], ["LC", "Lecco"], ["LI", "Livorno"], ["LO", "Lodi"], ["LU", "Lucca"], ["MC", "Macerata"], ["MN", "Mantova"], ["MS", "Massa-Carrara"], ["MT", "Matera"], ["ME", "Messina"], ["MI", "Milano"], ["MO", "Modena"], ["MB", "Monza e Brianza"], ["NA", "Napoli"], ["NO", "Novara"], ["NU", "Nuoro"], ["OR", "Oristano"], ["PD", "Padova"], ["PA", "Palermo"], ["PR", "Parma"], ["PV", "Pavia"], ["PG", "Perugia"], ["PU", "Pesaro e Urbino"], ["PE", "Pescara"], ["PC", "Piacenza"], ["PI", "Pisa"], ["PT", "Pistoia"], ["PN", "Pordenone"], ["PZ", "Potenza"], ["PO", "Prato"], ["RG", "Ragusa"], ["RA", "Ravenna"], ["RC", "Reggio Calabria"], ["RE", "Reggio Emilia"], ["RI", "Rieti"], ["RN", "Rimini"], ["RM", "Roma"], ["RO", "Rovigo"], ["SA", "Salerno"], ["SS", "Sassari"], ["SV", "Savona"], ["SI", "Siena"], ["SR", "Siracusa"], ["SO", "Sondrio"], ["SU", "Sud Sardegna"], ["TA", "Taranto"], ["TE", "Teramo"], ["TR", "Terni"], ["TO", "Torino"], ["TP", "Trapani"], ["TN", "Trento"], ["TV", "Treviso"], ["TS", "Trieste"], ["UD", "Udine"], ["VA", "Varese"], ["VE", "Venezia"], ["VB", "Verbano-Cusio-Ossola"], ["VC", "Vercelli"], ["VR", "Verona"], ["VV", "Vibo Valentia"], ["VI", "Vicenza"], ["VT", "Viterbo"]];

  var TEXTS = {
    it: { company: 'Struttura / azienda (facoltativo)', country: 'Nazione', province: 'Provincia', city: 'Città', choose: 'Seleziona…', other: 'Altro paese' },
    en: { company: 'Property / company (optional)', country: 'Country', province: 'Province', city: 'City', choose: 'Select…', other: 'Other country' },
    de: { company: 'Betrieb / Unternehmen (optional)', country: 'Land', province: 'Provinz', city: 'Ort', choose: 'Bitte wählen…', other: 'Anderes Land' },
    fr: { company: 'Établissement / entreprise (facultatif)', country: 'Pays', province: 'Province', city: 'Ville', choose: 'Sélectionner…', other: 'Autre pays' },
  };
  function lang() {
    var code = (document.documentElement.lang || 'it').slice(0, 2).toLowerCase();
    return TEXTS[code] ? code : 'it';
  }
  function t(key) {
    return TEXTS[lang()][key];
  }

  // ── Provenienza della visita ──────────────────────────────────────────────
  var SEARCH_ENGINES = ['google', 'bing', 'yahoo', 'duckduckgo', 'ecosia', 'yandex', 'baidu', 'qwant', 'brave', 'startpage'];
  var SOCIAL = ['facebook', 'instagram', 'linkedin', 'lnkd.in', 'pinterest', 'youtube', 'tiktok', 't.co', 'twitter', 'x.com', 'threads'];
  // Pagamento e checkout riportano sul sito: non sono una provenienza.
  var IGNORED = ['nexi.it', 'paypal.com', 'shopify.com', 'shop.app', 'myshopify.com', 'stripe.com', 'klarna.com'];

  function hostOf(url) {
    try { return new URL(url).hostname.replace(/^www\./, '').toLowerCase(); } catch (e) { return ''; }
  }
  function matches(host, list) {
    return list.some(function (name) {
      return host === name || host.slice(-name.length - 1) === '.' + name || host.split('.').indexOf(name) !== -1;
    });
  }
  function readAttribution() {
    try {
      var data = JSON.parse(window.localStorage.getItem(STORE_KEY) || 'null');
      if (data && data.last && Date.now() - Date.parse(data.last.at) < MAX_AGE) return data;
    } catch (e) {}
    return null;
  }
  function saveAttribution(data) {
    try { window.localStorage.setItem(STORE_KEY, JSON.stringify(data)); } catch (e) {}
  }

  function currentTouch() {
    var params = new URLSearchParams(window.location.search);
    function param(key) { return (params.get(key) || '').trim().slice(0, 200); }
    var touch = {};
    ['gclid', 'gbraid', 'wbraid', 'fbclid', 'msclkid'].forEach(function (key) {
      if (param(key)) touch[key] = param(key);
    });
    var own = window.location.hostname.replace(/^www\./, '').toLowerCase();
    var refHost = hostOf(document.referrer);
    if (refHost && (refHost === own || matches(refHost, [own]) || matches(refHost, IGNORED))) refHost = '';

    if (param('utm_source')) {
      touch.source = param('utm_source').toLowerCase();
      touch.medium = (param('utm_medium') || '(not set)').toLowerCase();
      touch.campaign = param('utm_campaign');
      touch.term = param('utm_term');
      touch.content = param('utm_content');
    } else if (touch.gclid || touch.gbraid || touch.wbraid) {
      touch.source = 'google'; touch.medium = 'cpc';
    } else if (touch.msclkid) {
      touch.source = 'bing'; touch.medium = 'cpc';
    } else if (refHost) {
      var engine = SEARCH_ENGINES.filter(function (name) { return refHost.split('.').indexOf(name) !== -1; })[0];
      if (engine) { touch.source = engine; touch.medium = 'organic'; }
      else if (matches(refHost, SOCIAL)) { touch.source = refHost; touch.medium = 'social'; }
      else { touch.source = refHost; touch.medium = 'referral'; }
    } else if (touch.fbclid) {
      touch.source = 'facebook'; touch.medium = 'social';
    } else {
      return null;
    }
    if (refHost) touch.referrer = document.referrer.slice(0, 300);
    // Solo il percorso: la query puo' contenere dati personali.
    touch.landing_page = window.location.pathname;
    touch.at = new Date().toISOString();
    Object.keys(touch).forEach(function (key) { if (!touch[key]) delete touch[key]; });
    return touch;
  }

  // Come GA4: una visita diretta non cancella l'ultima provenienza nota.
  function trackVisit() {
    // Solo la pagina vera: non gli iframe (about:blank, sandbox) che riportano il genitore come referrer.
    if (window.self !== window.top || !/^https?:$/.test(window.location.protocol)) return;
    var data = readAttribution();
    var touch = currentTouch();
    if (!touch) {
      if (data) return;
      touch = { source: '(direct)', medium: '(none)', landing_page: window.location.pathname, at: new Date().toISOString() };
    }
    data = data || { first: touch };
    data.last = touch;
    saveAttribution(data);
  }

  function gaClientId() {
    var match = document.cookie.match(/(?:^|; )_ga=GA\d\.\d\.(\d+\.\d+)/);
    return match ? match[1] : '';
  }

  function attribution() {
    var data = readAttribution() || {};
    var out = {};
    if (data.last) out.last = data.last;
    if (data.first) out.first = data.first;
    var ga = gaClientId();
    if (ga) out.ga_client_id = ga;
    return out;
  }

  // ── Dati del cliente registrato ───────────────────────────────────────────
  var customer = null;
  function readCustomer() {
    var el = document.getElementById('site-request-customer');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  // Fatturazione dichiarata, se ha almeno la citta'; altrimenti l'indirizzo predefinito.
  function customerLocation(data) {
    var pick = [data.billing, data.address].filter(function (a) { return a && a.city; })[0];
    if (!pick) return null;
    return {
      country: String(pick.country_code || '').toUpperCase(),
      province: String(pick.province_code || '').toUpperCase(),
      city: pick.city,
    };
  }

  // ── Campi nei moduli ──────────────────────────────────────────────────────
  var SKIPPED_IDS = ['WithdrawalForm', 'FormStockNotify'];
  var SKIPPED_KINDS = ['avviso_disponibilita', 'recesso', 'verifica_vies'];

  function isContactForm(form) {
    var type = form.querySelector('input[name="form_type"]');
    return !!type && type.value === 'contact';
  }
  function wantsFields(form) {
    if (!isContactForm(form) || form.hasAttribute('data-site-request-no-location')) return false;
    if (SKIPPED_IDS.indexOf(form.id) !== -1) return false;
    if (SKIPPED_KINDS.indexOf(form.dataset.siteRequestKind || '') !== -1) return false;
    if (form.classList.contains('fiscal-onboarding__contact-form') || form.classList.contains('stock-notify-form')) return false;
    return !!emailInput(form);
  }
  function emailInput(form) {
    return form.querySelector('input[name="contact[email]"], input[type="email"]');
  }
  // Il contenitore piu' esterno che racchiude solo quel campo (campo + etichetta).
  function fieldBox(control, form) {
    var box = control;
    while (box.parentElement && box.parentElement !== form &&
      box.parentElement.querySelectorAll('input:not([type="hidden"]), select, textarea').length === 1) {
      box = box.parentElement;
    }
    return box;
  }

  function countryName(code, names) {
    if (code === OTHER_COUNTRY) return t('other');
    try { return names.of(code) || code; } catch (e) { return code; }
  }
  function countryOptions() {
    var names = null;
    try { names = new Intl.DisplayNames([lang()], { type: 'region' }); } catch (e) {}
    var rest = COUNTRIES.slice(1).map(function (code) { return [code, names ? countryName(code, names) : code]; });
    rest.sort(function (a, b) { return a[1].localeCompare(b[1], lang()); });
    return [['IT', names ? countryName('IT', names) : 'Italia']].concat(rest, [[OTHER_COUNTRY, t('other')]]);
  }

  var counter = 0;
  function makeField(template, original, spec) {
    var box = template === original ? document.createElement('div') : template.cloneNode(true);
    box.classList.add('site-request-extra');
    box.removeAttribute('id');
    box.querySelectorAll('[id]').forEach(function (el) { el.removeAttribute('id'); });
    box.querySelectorAll('small, [role="alert"], .form__message, .input-error, .field-error, .error').forEach(function (el) { el.remove(); });
    var oldControl = box.querySelector('input') || box.appendChild(document.createElement('input'));
    var control = document.createElement(spec.options ? 'select' : 'input');
    if (original.className) control.className = original.className;
    if (!spec.options) {
      control.type = 'text';
      if (original.hasAttribute('placeholder')) control.placeholder = spec.label;
    } else {
      control.appendChild(new Option(t('choose'), ''));
      spec.options.forEach(function (option) { control.appendChild(new Option(option[1], option[0])); });
    }
    control.id = 'SiteRequest-' + spec.key + '-' + (++counter);
    control.name = 'contact[' + spec.shopifyName + ']';
    control.setAttribute('autocomplete', spec.autocomplete);
    control.dataset.siteRequestField = spec.key;
    if (spec.required) { control.required = true; control.setAttribute('aria-required', 'true'); }
    oldControl.replaceWith(control);

    var labels = box.querySelectorAll('label');
    if (!labels.length && template === original) {
      var label = document.createElement('label');
      box.insertBefore(label, control);
      labels = [label];
    }
    Array.prototype.forEach.call(labels, function (label) {
      var star = /\*\s*$/.test(label.textContent) && spec.required ? ' *' : '';
      label.htmlFor = control.id;
      label.textContent = spec.label + star;
      if (label.hasAttribute('placeholder')) label.setAttribute('placeholder', spec.label);
    });
    // Moduli senza etichette (solo segnaposto): il menu dice cosa chiede.
    if (!labels.length) {
      control.setAttribute('aria-label', spec.label);
      if (spec.options) control.options[0].text = spec.label;
    }
    return box;
  }

  function setProvinceVisible(box, visible) {
    var select = box.querySelector('select');
    box.hidden = !visible;
    select.disabled = !visible;
    select.required = visible;
  }

  function prefill(form, fields) {
    var data = customer;
    var defaultCountry = (window.Shopify && window.Shopify.country) || '';
    var where = data ? customerLocation(data) : null;
    var country = where && where.country ? where.country : defaultCountry;
    if (country && COUNTRIES.indexOf(country) === -1) country = where ? OTHER_COUNTRY : '';
    if (country) fields.country.value = country;
    if (where) {
      if (where.province && fields.province.querySelector('option[value="' + where.province + '"]')) fields.province.value = where.province;
      fields.city.value = where.city;
    }
    if (!data) return;
    if (data.company) fields.company.value = data.company;
    var name = form.querySelector('input[autocomplete="name"]');
    if (name && !name.value && data.name) name.value = data.name;
    var email = emailInput(form);
    if (email && !email.value && data.email) email.value = data.email;
    var phone = form.querySelector('input[type="tel"], input[autocomplete="tel"]');
    var phoneValue = data.phone || (data.billing && data.billing.phone) || '';
    if (phone && !phone.value && phoneValue) {
      // Alcuni temi accettano solo cifre: un numero che il campo rifiuta non si precompila.
      phone.value = phoneValue;
      if (!phone.checkValidity()) phone.value = '';
    }
  }

  function addFields(form) {
    if (form.dataset.siteRequestFields || !wantsFields(form)) return;
    form.dataset.siteRequestFields = '1';
    var email = emailInput(form);
    var template = fieldBox(email, form);
    var phone = form.querySelector('input[type="tel"], input[autocomplete="tel"]');
    var anchor = phone ? fieldBox(phone, form) : template;
    var specs = [
      { key: 'company', shopifyName: 'Struttura / azienda', label: t('company'), autocomplete: 'organization' },
      { key: 'country', shopifyName: 'Nazione', label: t('country'), autocomplete: 'country', required: true, options: countryOptions() },
      { key: 'province', shopifyName: 'Provincia', label: t('province'), autocomplete: 'address-level1', required: true, options: PROVINCES },
      { key: 'city', shopifyName: 'Città', label: t('city'), autocomplete: 'address-level2', required: true },
    ];
    var boxes = {};
    var fields = {};
    specs.forEach(function (spec) {
      var box = makeField(template, email, spec);
      anchor.after(box);
      anchor = box;
      boxes[spec.key] = box;
      fields[spec.key] = box.querySelector('[data-site-request-field]');
    });
    prefill(form, fields);
    function syncProvince() { setProvinceVisible(boxes.province, fields.country.value === 'IT'); }
    fields.country.addEventListener('change', syncProvince);
    syncProvince();
  }

  function scan(root) {
    if (root instanceof HTMLFormElement) addFields(root);
    if (root.querySelectorAll) root.querySelectorAll('form').forEach(addFields);
  }

  function collect(form) {
    var out = {};
    form.querySelectorAll('[data-site-request-field]').forEach(function (el) {
      var value = (el.value || '').trim();
      if (!el.disabled && value) out[el.dataset.siteRequestField] = value;
    });
    out.attribution = attribution();
    return out;
  }

  window.SiteRequestFields = { collect: collect, attribution: attribution };

  trackVisit();

  var style = document.createElement('style');
  style.textContent = '.site-request-extra[hidden]{display:none!important}';
  document.head.appendChild(style);

  function init() {
    customer = readCustomer();
    scan(document);
    // Moduli aggiunti dopo (popup, schede caricate al volo).
    new MutationObserver(function (records) {
      records.forEach(function (record) {
        record.addedNodes.forEach(function (node) { if (node.nodeType === 1) scan(node); });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
